import { defineGlobalStyles } from "@chakra-ui/react";

export const globalCss = defineGlobalStyles({});
